import { Filter } from '../../models';

export const newsFilter: Filter[] = [
  {
    title: 'Published',
    type: 'date-range',
    minDate: '0001-01-01',
    maxDate: '9999-12-31',
    field: 'date_published',
  },
  {
    title: 'Content type',
    field: 'content_type_news.enum',
    metadataField: 'content_type_news',
    options: [
      { title: 'Advice article', value: 'Advice article', metadataValue: 'advice-article' },
      { title: 'Media release', value: 'Media release', metadataValue: 'media-release' },
      { title: 'Podcast', value: 'Podcast', metadataValue: 'podcast' },
    ],
  },
  {
    title: 'Category',
    field: 'news_categories.keyword',
    metadataField: 'news_categories',
    options: [
      { title: 'Alumni', value: 'alumni', metadataValue: 'alumni' },
      { title: 'Art and design', value: 'art and design', metadataValue: 'art-and-design' },
      {
        title: 'Business innovation and law',
        value: 'business innovation and law',
        metadataValue: 'business-innovation-and-law',
      },
      { title: 'Campus and community', value: 'campus and global community', metadataValue: 'campus-and-community' },
      { title: 'Environment', value: 'environment', metadataValue: 'environment' },
      { title: 'Health', value: 'health', metadataValue: 'health' },
      { title: 'Research', value: 'research', metadataValue: 'research' },
      { title: 'Science and engineering', value: 'science and engineering', metadataValue: 'science-and-engineering' },
      { title: 'Society and culture', value: 'society and culture', metadataValue: 'society-and-culture' },
      { title: 'Space and physics', value: 'space and physics', metadataValue: 'space-and-physics' },
      { title: 'Technology', value: 'technology', metadataValue: 'technology' },
    ],
  },
];
